import { Box } from '@mantine/core';
import { useReducedMotion } from '@mantine/hooks';
import type { CSSProperties } from 'react';

export function SiestaBackground() {
  const reducedMotion = useReducedMotion(undefined, { getInitialValueInEffect: false });

  return (
    <>
      {reducedMotion ? (
        <img
          src="/sidebar-background-poster.webp"
          alt=""
          aria-hidden="true"
          style={backgroundMediaStyle}
        />
      ) : (
        <video autoPlay loop muted playsInline style={backgroundMediaStyle}>
          <source src="/sidebar-background.mp4" type="video/mp4" />
        </video>
      )}

      <Box
        pos="absolute"
        style={{
          inset: 0,
          backgroundColor: 'rgba(255, 119, 28, 0.7)',
          zIndex: 1,
        }}
      />
    </>
  );
}

const backgroundMediaStyle: CSSProperties = {
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  zIndex: 0,
};
